import { render, staticRenderFns } from "./_share_record_form.vue?vue&type=template&id=b09ccee8&scoped=true&"
import script from "./_share_record_form.vue?vue&type=script&lang=js&"
export * from "./_share_record_form.vue?vue&type=script&lang=js&"
import style0 from "./_share_record_form.vue?vue&type=style&index=0&id=b09ccee8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09ccee8",
  null
  
)

export default component.exports